export enum eScreenSize {
  XS = 320,
  SM = 375,
  MD = 425,
  LG = 768,
  XL = 1024,
  XXL = 1440,
}

export enum eDisplayMode {
  MOBILE,
  DESKTOP,
}
